import { useQuery } from '@tanstack/react-query'
import knowledgeApi from '@/lib/knowledge-api'
import type { DataTablesResponse, InteractionListItem } from '../types'

interface UseInteractionsParams {
  page: number
  pageSize: number
  search: string
  orderColumn: number
  orderDirection: 'asc' | 'desc'
}

export function useInteractions({
  page,
  pageSize,
  search,
  orderColumn,
  orderDirection,
}: UseInteractionsParams) {
  return useQuery({
    queryKey: ['interactions', page, pageSize, search, orderColumn, orderDirection],
    queryFn: async () => {
      const start = (page - 1) * pageSize
      
      const response = await knowledgeApi.get<DataTablesResponse<InteractionListItem>>(
        '/knowledge/interactions/data/',
        {
          params: {
            draw: 1,
            start,
            length: pageSize,
            'search[value]': search,
            'order[0][column]': orderColumn,
            'order[0][dir]': orderDirection,
          },
        }
      )

      return response.data
    },
    staleTime: 30000, // 30 seconds
  })
}
